var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ViewUiCalloutIcon',{staticClass:"view-ui-state-nodiagrams",attrs:{"iconFilename":"rack-9ball.svg","message":'There are no<br />diagrams yet'}})
}
var staticRenderFns = []

export { render, staticRenderFns }